<template>
  <form class="form-group" @submit.prevent="handleSubmit" ref="formRef">
    <label for="logoFile">📷 Logo de la compagnie</label>
    <input
      type="file"
      id="logoFile"
      accept="image/*"
      @change="handleFileChange"
    />
    <!-- Prévisualisation : logo existant OU nouvelle sélection -->
    <div v-if="logoPreview || existingLogoUrl" class="preview">
      <img
        :src="logoPreview || existingLogoUrl"
        alt="Aperçu"
      />
      <div class="preview-actions">
        <button
          v-if="logoPreview"
          type="button"
          @click="removeFile"
          class="btn btn-secondary"
        >
          Supprimer le nouveau logo
        </button>
        <span v-if="existingLogoUrl && !logoPreview" class="preview-label">
          Logo actuel
        </span>
        <span v-if="logoPreview" class="preview-label">
          Nouveau logo (remplacera l'ancien)
        </span>
      </div>
    </div>


      <label for="name">Nom de la compagnie *</label>
      <input
        v-model="localData.name"
        type="text"
        id="name"
        placeholder="Ex: Trans-Cameroun"
        required
      />
      <label for="addressId">Adresse</label>
      <select v-model="localData.addressId" id="addressId">
        <option value="">-- Sélectionner une adresse --</option>
        <option v-for="address in addresses" :key="address.id" :value="address.id">
          {{ address.name }} - {{ address.city?.name }}
        </option>
      </select>
    <div v-if="error" class="error-message">{{ error }}</div>
  </form>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { config } from '@/config/env.js'

const props = defineProps({
  formData: { type: Object, default: () => ({ name: '', slug: '', addressId: '', logoName: '' }) },
  addresses: { type: Array, default: () => [] }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')
const logoPreview = ref(null)
const existingLogoUrl = ref(null)

const localData = ref({
  name: props.formData?.name || '',
  slug: props.formData?.slug || '',
  addressId: props.formData?.addressId || '',
  logoFile: null
})

// Charger le logo existant si il existe
onMounted(() => {
  if (props.formData?.logoName) {
    // Construire l'URL vers l'image existante
    // existingLogoUrl.value = `${config.apiUrl.replace('/api', '')}/uploads/vehicles/${props.formData.thumbnailName}`
    existingLogoUrl.value = `${config.apiUrl}/uploads/logo/${props.formData.logoName}`
  }
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      name: newFormData.name || '',
      slug: newFormData.slug || '',
      addressId: newFormData.addressId || '',
      logoFile: null
    }

    if(newFormData.logoName) {
      existingLogoUrl.value = `${config.apiUrl}/uploads/logo/${newFormData.logoName}`
    } else {
      existingLogoUrl.value = null
    }

    logoPreview.value = null
  }
}, { deep: true })

function handleFileChange(event) {
  const file = event.target.files[0]

  if (!file) {
    localData.value.logoFile = null
    logoPreview.value = null
    return
  }

  // Validation : taille max 5MB
  if (file.size > 5 * 1024 * 1024) {
    error.value = 'Le fichier est trop volumineux (max 5MB)'
    event.target.value = ''
    return
  }

  // Validation : type image uniquement
  if (!file.type.startsWith('image/')) {
    error.value = 'Seules les images sont acceptées'
    event.target.value = ''
    return
  }

  // Stocker le fichier
  localData.value.logoFile = file
  error.value = ''

  // Créer une prévisualisation du nouveau fichier
  const reader = new FileReader()
  reader.onload = (e) => {
    logoPreview.value = e.target.result
  }
  reader.readAsDataURL(file)
}

// Supprimer le nouveau fichier sélectionné
function removeFile() {
  localData.value.logoFile = null
  logoPreview.value = null
  const fileInput = document.getElementById('logoFile')
  if (fileInput) fileInput.value = ''
}

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
